export default axios => ({
  getList(payload) {
    return axios.get('/department', payload);
  }
})
